import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FormService } from '../services/form.service';
import { MailService } from '../services/mail.service';
import { phoneValidator } from 'src/app/shared/utils/form-utils';

@Component({
	selector: 'app-finish',
	templateUrl: './finish.component.html',
	styleUrls: ['./finish.component.scss'],
})
export class FinishComponent {
	subtitle: string = `En los próximos días te enviaremos el contrato al e-mail que nos has indicado para que lo revises y lo firmes. <br><br>
	A continuación, necesitamos que selecciones el método de firma del contrato que desearás utilizar cuando te lo enviemos.`;
	step: number = 1;
	buttonLabel: string = 'Volver';
	public switchAutorizacion?: boolean;
	switchTratamientoDatos: boolean = false;

	telefono: FormControl = new FormControl('', [Validators.required, phoneValidator()]);

	get telefonoError(): string {
		if (!this.telefono.invalid || !this.telefono.touched) return '';
		if (this.telefono.hasError('required')) return 'El teléfono es requerido.';
		if (this.telefono.hasError('invalidPhone')) return 'El formato del teléfono no es válido. Introduce un número de 9 dígitos.';
		return '';
	}

	form = new FormGroup({
		telefono: this.telefono,
	});

	showModal: boolean = false;
	phoneValid: boolean = false;
	enableSendInformation: boolean = true;
	isLoading: boolean = false;

	constructor(private router: Router, public formService: FormService, private readonly mail: MailService) {}

	ngOnInit(): void {}

	buttonAction(option: number) {
		if (this.step === 1) this.router.navigate(['/resume']);
	}

	public valueChange(event: any, value: string): void {
		const valueSelected = event.find((val: any) => {
			return !!val.value;
		});

		if (value === 'switchAutorizacion') {
			if (!!valueSelected) {
				this.switchAutorizacion = valueSelected.value && valueSelected.id === 'yes';
				this.enableSendInformation = valueSelected.id === 'no';
				this.formService.setForm({ telefonoOTP: undefined });
				this.phoneValid = false;
			} else if (valueSelected === undefined) {
				this.switchAutorizacion = undefined;
				this.enableSendInformation = true;
				this.formService.setForm({ telefonoOTP: undefined });
			}
		}
	}

	public sendOTPCode(): void {
		if (this.form.invalid) return;

		const telefonoOTP = this.telefono.value;
		if (telefonoOTP) this.formService.setForm({ telefonoOTP });

		this.phoneValid = true;
		this.enableSendInformation = false;
	}

	public sendInformationEmail(): void {
		if (this.enableSendInformation) return;

		this.enableSendInformation = true;
		this.isLoading = true;

		//recopilar la información de todo el formulario y mandarla al correo formateada
		this.mail.sendMailFormatted(this.formService.getForm()).subscribe({
			next: (data) => {
				this.showModal = true;
				this.isLoading = false;
			},
			error: () => {
				this.enableSendInformation = false;
				this.isLoading = false;
			},
		});
	}

	closeModal(event: any) {
		switch (event) {
			//Guardar
			case 'buttonPrimary':
				this.showModal = false;
				this.enableSendInformation = true;
				this.formService.resetForm();
				this.router.navigate(['/']);
				break;
			//Cancelar
			case 'buttonSecondary':
				this.showModal = false;
				this.enableSendInformation = true;
				this.formService.resetForm();
				this.router.navigate(['/']);
				break;
			default:
				this.showModal = false;
				this.enableSendInformation = true;
				this.formService.resetForm();
				this.router.navigate(['/']);
				break;
		}
	}
}
